import { DxScrollViewModule, DxButtonModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar.component';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from 'src/app/directives/directives/directives.module';
import { IsRouteActivePipe } from 'src/app/pipes/is-route-active.pipe';
import { StateButtonModule } from 'src/app/widgets/state-button/state-button.module';
import { TreeViewNodeModule } from 'src/app/widgets/tree-view/tree-view-node/tree-view-node.module';

@NgModule({
	providers: [
		IsRouteActivePipe,
	],
	declarations: [
		NavbarComponent
	],
	imports: [
		CommonModule,
		RouterModule.forChild([]),

		DirectivesModule,

		IsRouteActivePipe,

		TreeViewNodeModule,
		StateButtonModule,

		DxScrollViewModule,
		DxButtonModule,
	],
	exports: [
		NavbarComponent,
	],
})
export class NavbarModule { }
